import styled from 'styled-components'

export const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 20px;
`
export const StyledClose = styled.div`
  svg {
    width: 2em;
    height: 2em;

    path {
      stroke: #fff;
      stroke-width: 0.78;
    }
  }
`

export const TitleContainer = styled.div`
  width: 100%;
  margin-top: 10px;
  padding: 0;
  border-bottom: solid 4px white;

  > div {
    font-size: 24px !important;
  }
`
export const SubtitleContainer = styled.div`
  width: 100%;
  padding: 0px;

  > div {
    font-size: 18px !important;
    text-transform: uppercase;
  }
`